import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { DataUser, RememberUser } from 'src/app/utils/models';

@Injectable()
export class EncryptService {
  private readonly secretKey = 'B3rS3rK3$&$%&/45';

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  //Descriptamiento
  Descriptamiento(msg: string) {
    var mensajeSecreto = atob(msg);
    var mensajeParciado = mensajeSecreto.split('|');
    var mensajeBas64 = mensajeParciado[0];
    var llave = mensajeParciado[1];

    var key = CryptoJS.enc.Base64.parse(llave);
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);

    var decrypted = CryptoJS.AES.decrypt(mensajeBas64.toString(), key, {
      iv: iv,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  //Encriptamiento del mensaje
  Encriptamiento(msg: string): Promise<string> {
    return new Promise((resolve, reject) => {
      var encryptSecretKey = String(Math.random() * (100000 - 1000) + 1);
      var keySize = 256;

      var salt = CryptoJS.lib.WordArray.random(16);
      var key = CryptoJS.PBKDF2(encryptSecretKey, salt, {
        keySize: keySize / 32,
        iterations: 100,
      });

      var iv = CryptoJS.lib.WordArray.random(128 / 8);
      var encrypted = CryptoJS.AES.encrypt(msg, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      });

      var result = CryptoJS.enc.Base64.stringify(
        salt.concat(iv).concat(encrypted.ciphertext)
      );

      var bas64 = btoa(result + '|' + encryptSecretKey);

      resolve(bas64);
    });
  }

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }

  decrypt(textToDecrypt: string): string {
    return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(
      CryptoJS.enc.Utf8
    );
  }

  createSession(dataUser: DataUser): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('session', this.encrypt(JSON.stringify(dataUser)));
    }
  }

  getSession() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('session') != undefined) {
        const local = localStorage.getItem('session') || '';
        let session;
        try {
          session = JSON.parse(this.decrypt(local));
        } catch (e) {
          session = '';
        }
        return session;
      }
    }
    return '';
  }

  createRemember(dataUser: RememberUser): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('remember', this.encrypt(JSON.stringify(dataUser)));
    }
  }

  getRemember(): RememberUser | string {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('remember') != undefined) {
        const local = localStorage.getItem('remember') || '';
        let remember;
        try {
          remember = JSON.parse(this.decrypt(local));
        } catch (e) {
          remember = '';
        }
        return remember;
      }
    }
    return '';
  }
}
